<template>
    <v-form ref="form" @submit.prevent>
        <v-layout class="password-creation" row wrap>
            <v-flex xs12 py-0>
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Anrede*' | translation }}</p>
                <v-select
                    v-model="salutation"
                    :items="salutations"
                    :rules="[rules.required]"
                    :label="inputLabelOutside ? '' : $language.translate('Anrede*')"
                    required
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>

            <v-flex xs12 py-0>
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Vorname*' | translation }}</p>
                <v-text-field
                    v-model="firstName"
                    :rules="[rules.required, rules.firstName]"
                    :label="inputLabelOutside ? '' : $language.translate('Vorname*')"
                    required
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>

            <v-flex xs12 py-0>
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Nachname*' | translation }}</p>
                <v-text-field
                    v-model="lastName"
                    :rules="[rules.required]"
                    :label="inputLabelOutside ? '' : $language.translate('Nachname*')"
                    required
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>

            <v-flex xs12 py-0>
                <v-radio-group v-model="shippingToPackingStationComputed" row :disabled="disabled" class="mt-0" hide-details>
                    <div slot="label">{{ 'Delivery to a packing station' | translation }}</div>

                    <v-radio
                        :label="$language.translate('Ja')"
                        :value="true"
                    />
                    <v-radio
                        :label="$language.translate('Nein')"
                        :value="false"
                    />
                </v-radio-group>

                <div class="pa-2 my-2 packing-station-container" v-if="shippingToPackingStationComputed">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Packstation' | translation }}</p>
                            <v-text-field
                                v-model="packingStation"
                                :label="inputLabelOutside ? '' : $language.translate('Packstation')"
                                :disabled="disabled"
                                class="pt-0"
                            />
                        </v-flex>

                        <v-flex xs6>
                            <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Postnummer' | translation }}</p>
                            <v-text-field
                                v-model="packingStationPostCode"
                                :label="inputLabelOutside ? '' : $language.translate('Postnummer')"
                                :disabled="disabled"
                                class="pt-0"
                            />
                        </v-flex>

                        <v-flex xs6 align-self-center class="text-xs-center dhl-logo-wrapper">
                            <img class="dhl-logo" src="../../../assets/dhl-packstation.jpg"></img>
                        </v-flex>
                    </v-layout>
                </div>
            </v-flex>

            <v-flex xs12 py-0 v-if="!isUserLoggedIn">
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Email*' | translation }}</p>
                <v-text-field
                    v-model="email"
                    :rules="[rules.required, rules.email]"
                    :label="inputLabelOutside ? '' : $language.translate('Email*')"
                    required
                    :error-messages="errors['email']"
                    @change="resetErrors('email')"
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>

            <v-flex xs12 v-if="!isUserLoggedIn && askPassword" py-0>
                <p class="body-2 ma-0" v-if="inputLabelOutside">{{ 'Passwort*' | translation }}</p>
                <v-text-field
                    v-model="password"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :rules="[rules.required, rules.length]"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    :label="inputLabelOutside ? '' : $language.translate('Passwort*')"
                    required
                    browser-autocomplete="new-password"
                    :error-messages="errors['password']"
                    @change="resetErrors('password')"
                    :disabled="disabled"
                    class="pt-0"
                />
            </v-flex>
        </v-layout>
    </v-form>
</template>

<style scoped>
    .packing-station-container {
        border: 1px solid #0000008a;
    }

    .dhl-logo-wrapper {
        height: 60px;
    }

    .dhl-logo {
        height: 100%;
    }
</style>

<script>
    import {createNamespacedHelpers} from 'vuex';
    import Registration from '../default/Registration';

    const moduleName = 'Registration';
    const {mapState, mapGetters, mapMutations} = createNamespacedHelpers(moduleName);

    export default {
        extends: Registration,
        data(){
            return {
                shippingToPackingStation: false,
            };
        },
        computed: {
            packingStation: {
                get() {
                    return this.getPackingStation();
                },
                set(value) {
                    this.setPackingStation(value);
                },
            },
            packingStationPostCode: {
                get() {
                    return this.getPackingStationPostCode();
                },
                set(value) {
                    this.setPackingStationPostCode(value);
                },
            },
            shippingToPackingStationComputed: {
                get() {
                    return this.shippingToPackingStation || Boolean(this.packingStation);
                },
                set(value) {
                    if (!value) {
                        this.setPackingStation(null);
                        this.setPackingStationPostCode(null);
                    }

                    this.shippingToPackingStation = value;
                },
            },
        },
        methods: {
            ...mapGetters([
                'getPackingStation',
                'getPackingStationPostCode',
            ]),
            ...mapMutations([
                'setPackingStation',
                'setPackingStationPostCode',
            ]),
        }
    };
</script>
